/**
 * Shared Type Definitions for Spellion
 *
 * This file contains type definitions shared between frontend and backend.
 * Types are organized by domain as specified in the design document.
 */
// ============================================================================
// User Domain Types
// ============================================================================
export var UserRole;
(function (UserRole) {
    UserRole["FREE"] = "free";
    UserRole["PREMIUM"] = "premium";
    UserRole["ADMIN"] = "admin";
})(UserRole || (UserRole = {}));
export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["FREE"] = "free";
    SubscriptionType["PREMIUM"] = "premium";
})(SubscriptionType || (SubscriptionType = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "active";
    SubscriptionStatus["CANCELLED"] = "cancelled";
    SubscriptionStatus["EXPIRED"] = "expired";
})(SubscriptionStatus || (SubscriptionStatus = {}));
// ============================================================================
// Search Domain Types
// ============================================================================
export var SearchType;
(function (SearchType) {
    SearchType["ANAGRAM"] = "anagram";
    SearchType["PATTERN"] = "pattern";
    SearchType["VERIFY"] = "verify";
})(SearchType || (SearchType = {}));
// ============================================================================
// Dictionary Domain Types
// ============================================================================
export var DictionaryType;
(function (DictionaryType) {
    DictionaryType["SYSTEM"] = "system";
    DictionaryType["CUSTOM"] = "custom";
})(DictionaryType || (DictionaryType = {}));
// ============================================================================
// Validation Constants
// ============================================================================
export const VALIDATION = {
    /** Maximum length for search input and words */
    MAX_WORD_LENGTH: 64,
    /** Minimum length for search input */
    MIN_WORD_LENGTH: 1,
    /** Maximum number of jokers allowed in anagram search */
    MAX_JOKERS: 2,
    /** Joker character for searches */
    JOKER_CHAR: '*',
    /** Valid letters pattern (A-Z, French accented letters) */
    VALID_LETTERS_REGEX: /^[A-ZÀÂÇÉÈÊËÎÏÔÙÛÜŸŒÆ*]+$/i,
    /** Email validation regex */
    EMAIL_REGEX: /^[^@]+@[^@]+\.[^@]+$/,
    /** Password constraints */
    PASSWORD_MIN_LENGTH: 8,
    PASSWORD_MAX_LENGTH: 128,
    /** Daily search limit for free users */
    FREE_USER_DAILY_LIMIT: 20,
    /** Maximum custom dictionaries for premium users */
    MAX_CUSTOM_DICTIONARIES: 5,
    /** Maximum dictionary file size in bytes (150 MB) */
    MAX_DICTIONARY_FILE_SIZE: 150 * 1024 * 1024
};
//# sourceMappingURL=index.js.map